import axios from 'axios';
import authHeader from './auth-header';
import { API_ADMIN_URL } from './config';

const API_URL = API_ADMIN_URL + "/";

class ToolService {

  getTool() {
    return axios.get(API_URL + "tool", { headers: authHeader() });
  }

  getAttribute(tool) {
    return axios.get(API_URL + "products/" + tool, { headers: authHeader() });
  }

  getVariations(idProduct) {
    return axios.get(API_URL + "products/" + idProduct + "/variations", { headers: authHeader() });
  }
}

export default new ToolService();